import React from "react";
import { ScreenContentWrapper } from "../shared/ScreenContentWrapper";
import FormsFilesHeader from "views/formsAndFiles/FormsFilesHeader";
import { FileCabinetView } from "./FileCabinetView";

interface IProps {
  header?: JSX.Element,
  wrapContent?: boolean,
  includeOnlyDocumentTypeIds?: number[],
}

export const FileCabinetScreen = ({ header, includeOnlyDocumentTypeIds, wrapContent = true }: IProps): JSX.Element => {
  const includeOnlyDocumentTypeIdsMap: { [key: number]: boolean } = {}
  includeOnlyDocumentTypeIds?.map(docTypeId => {
    includeOnlyDocumentTypeIdsMap[docTypeId] = true
  })

  const withWrapper = (child: JSX.Element): JSX.Element => {
    if (wrapContent) {
      return <ScreenContentWrapper pageSuffix="File cabinet" hideImage={true}>
        {child}
      </ScreenContentWrapper>
    }

    return child
  }

  return (
    <>
      {header || <FormsFilesHeader
        title="My Files"
        description="We’ve created this area for you to help you stay organized.  As things change, you can re-upload your files and we’ll keep a copy of both the old and new document for you."
      />}
      {withWrapper(<FileCabinetView />)}
    </>
  );
};
